module.exports = __webpack_public_path__ + "media/vendor/leap/pages/assets/img/icons/theme/communication/readed-mail-7376c0eabe7d8adb46fafbc462711226.svg";